/* HorizontalNavRenderer.js */

"use strict";

class HorizontalNavRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("horizontal-nav-gl");
        this._rootElem.component = this._model;
        this._navItems = [];

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*, reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            //TODO set all class members to undefined here
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on(
            "ActiveNavItemSelected",
            (this._onNavItemSelected = this._onNavItemSelected.bind(this))
        );
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("ActiveNavItemSelected", this._onNavItemSelected);
    }
    _onNavItemSelected(prevValue, newValue) {
        let oldActiveItem = this._navItems.find((obj) => obj.dataset.value === prevValue);
        let newActiveItem = this._navItems.find((obj) => obj.dataset.value === newValue);

        if (oldActiveItem) {
            oldActiveItem.classList.remove("active");
        }
        if (newActiveItem) {
            newActiveItem.classList.add("active");
        }
    }
    _clearNavItemComponents() {
        this._navItems.forEach((option) => {
            option.removeEventListener("click", this._onNavItemClickHandler);
            option.remove();
        });
        this._navItems = [];
    }
    _renderNavItemOptions() {
        let optArray = this.model.getNavOptions();

        if (this.model.options.sort) {
            optArray = optArray.sort((a, b) => {
                if (a.value < b.value) {
                    return -1;
                }
                if (a.value > b.value) {
                    return 1;
                }
                return 0;
            });
        }

        optArray.forEach((opt) => {
            let navItem = document.createElement("nav-item");
            navItem.innerHTML = opt.label;
            navItem.dataset.value = opt.value;
            navItem.addEventListener(
                "click",
                (this._onNavItemClickHandler = this._onNavItemClickHandler.bind(this))
            );
            this._rootElem.appendChild(navItem);
            this._navItems.push(navItem);
        });
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        //Clear out any existing nav button components.
        this._clearNavItemComponents();

        //Add a new button for each item in the list.
        this._renderNavItemOptions();

        return Promise.resolve();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    //TODO Private Render Methods here
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }

    _onNavItemClickHandler(event) {
        let newVal = event.currentTarget.dataset.value;
        if (newVal !== this._model.selectedValue) {
            this._model.selectedValue = newVal;
        }
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = HorizontalNavRenderer;
